// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Avatar from 'material-ui/Avatar';
import {CardMedia} from 'material-ui/Card';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import AddIcon from 'material-ui/svg-icons/content/select-all';
import BlockIcon from 'material-ui/svg-icons/content/block';



class EditTournament extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      tournament: {
        id: "",
        name: "",
        venue: "",
        game_type: 13,
        start_date: moment(),
        end_date: moment(),
        age_groups: [],
        game_formats: [],
        banner: '',
        category: 20,
        sub_category: "",
        registration_amount: '',
        registration_contact_number: '',
        description: '',
        format_desc: '',
        prize_and_perks: '',
        partners: '',
        _online_registration_enabled: false,
        pay_later: false,
        is_visible:false,
      },
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      categories: {},
      sub_categories: {},
      age_groups: [],
      game_formats: [],

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleMultiselect = this.handleMultiselect.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
  }


  componentDidMount() {
    this.get_details_for_edit_tournament();
  }

  get_details_for_edit_tournament() {
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_for_edit_tournament/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues,
         game_types: data.game_type,
         tournament: data.tournament,
         age_groups: data.age_groups, 
         game_formats: data.game_formats,
         }))
       .catch(error => error);
  }

  postEditedTournament(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/edit_tournament/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) {
      formData.append(name, data[name]);
    }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleMultiselect(event) {
    console.log(event);
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one =  Object.assign({}, this.state.tournament);
    var ids = [];

    if(event){
       for (var i = 0, l = options.length; i < l; i++) {
      console.log(new_selected_one[name]);
              if (options[i].selected) {
                ids.push(options[i].value);
              }
          }
    }
    else{}
     new_selected_one[name] = ids; 
    this.setState({tournament: new_selected_one});
  }

  handleFile(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.tournament);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['banner'] = selectorFiles[0]
    this.setState({tournament: new_selected_one});
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one[name] = event.target.value
    console.log(new_selected_one);
    this.setState({tournament: new_selected_one});
  }
  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament);
    new_selected_one['start_date'] = date
    this.setState({tournament: new_selected_one});
  }
  handleEndDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament);
    new_selected_one['end_date'] = date
    this.setState({tournament: new_selected_one});
  }


  handleVenue(event){
    var new_selected_one =  Object.assign({}, this.state.tournament);
    new_selected_one['venue'] = event.target.value
    this.setState({tournament: new_selected_one});
  }
  
  handleCheck(event){
    console.log(event.target.name + event.target.checked)
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.tournament);
    new_selected_one[name] = event.target.checked
    this.setState({tournament: new_selected_one});

  }
  goBack(){
    this.props.history.goBack();
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    console.log(this.state.tournament);
    this.postEditedTournament(this.state.tournament, this.props);
    console.log('post');
    console.log(this.state);
  }
  render() {
    console.log(this.state.tournament);
    return(
      <div>
      <div className="col-md-12" >
          <div className="breadcrumps" style={{'paddingLeft': "1%",'paddingTop':"1%"}}>
                        <a href={'/#/partnerTournament'} >
                          <span>Events</span>
                        </a> 
                        <a  href={"/#/crud/viewTournament/" + this.state.tournament.id}>
                          <span>{this.state.tournament.name}</span>
                        </a>
                        <a>
                            <span>Edit</span>
                        </a>
          </div>
      </div>
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Tournament</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Name
              </div>
              <input type="text"
                style={styles.input}
                name="name"
                value={this.state.tournament.name}
                onChange={this.handleChange}/>
            </div>


            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" id="venue" className="col-md-5" style={styles.item_body} value={this.state.value}
                onChange={(e) =>{this.handleVenue(e)}} value={this.state.tournament.venue} >
                {
                  Object.keys(this.state.venues).map((key, index) => (
                  <option key={index} value={this.state.venues[key].id}  >{this.state.venues[key].name}</option>
                  ))
                }
              </select>              
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={moment(this.state.tournament.start_date)} onChange={this.handleStartDate}/>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Date
              </div>
              <DatePicker selected={moment(this.state.tournament.end_date)} onChange={this.handleEndDate}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Current logo
              </div>
              <div className="col-md-6" style={styles.input}>
                <CardMedia>
                  <img src={`https://api.sporthood.in${this.state.tournament.banner}`} alt=""/>
                </CardMedia>
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                New logo*
              </div>
              <input type="file" style={styles.input} name="banner" onChange={ (e) => this.handleFile(e.target.files) }/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Contact Number
              </div>
              <input type="text"
                style={styles.input}
                name="registration_contact_number"
                value={this.state.tournament.registration_contact_number}
                onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Description 
              </div>
              <textarea rows="4" cols="33" style={styles.input}  name="description" value={this.state.tournament.description}
                onChange={this.handleChange}>
                {this.state.tournament.description}
                </textarea>
            </div>
            
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Partners 
              </div>
              <textarea rows="2" cols="33" style={styles.input}  name="partners" value={this.state.tournament.partners}
                onChange={this.handleChange}>
                {this.state.tournament.partners}
                </textarea>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Online Registration
              </div>
             <input type="checkbox"
                    checked={this.state.tournament._online_registration_enabled}
                    ref="_online_registration_enabled"
                    name="_online_registration_enabled"
                    onChange={this.handleCheck}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Free Event
              </div>
             <input type="checkbox"
                    checked={this.state.tournament.pay_later}
                    ref="pay_later"
                    name="pay_later"
                    onChange={this.handleCheck}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Publish
              </div>
             <input type="checkbox"
                    checked={this.state.tournament.is_visible}
                    ref="is_visible"
                    name="is_visible"
                    onChange={this.handleCheck}/>
            </div>
            
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit" />
              <input className="button1" type="button" value="Cancel" style={{backgroundColor:'red',marginLeft:'10px'}} onClick={() => {this.goBack()}} />
            </div>
            
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
      </div>
    );
  }
}

export default EditTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editTournament/index.js